import Nullstack from 'nullstack';
export default function IconGrill({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-grill",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M19 8h-14a6 6 0 0 0 6 6h2a6 6 0 0 0 5.996 -5.775l.004 -.225z"
  }), "   ", Nullstack.element("path", {
    d: "M17 20a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z"
  }), "   ", Nullstack.element("path", {
    d: "M15 14l1 2"
  }), "   ", Nullstack.element("path", {
    d: "M9 14l-3 6"
  }), "   ", Nullstack.element("path", {
    d: "M15 18h-8"
  }), "   ", Nullstack.element("path", {
    d: "M15 5v-1"
  }), "   ", Nullstack.element("path", {
    d: "M12 5v-1"
  }), "   ", Nullstack.element("path", {
    d: "M9 5v-1"
  }), " ");
}